import Consumivel from "@/models/Consumivel";
import Profissional from "../models/Profissional";

export default class LiquidoPenetrante {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.material = "Aço Carbono";
    this.tecnica = "Técnica A - Visível";
    this.via = "Água / Úmida";
    this.tipo = "Tipo 2";
    this.temperatura = this.randomNumber() + " °C";
    this.superficie = "Escovada / Limpa";
    this.descontinuidades = [];
    this.norma = "ASME VIII, Div. 1, Ap. 8, Ed. 2004";
    this.itens = this.getDefaultItens();
    this.procedimento = "";
    this.observacao = "";
    this.penetrante = new Consumivel();
    this.revelador = new Consumivel();
    this.inspetor = new Profissional();
  }

  update(lp) {
    this.numero = lp.numero;
    this.data = lp.data;
    this.material = lp.material;
    this.tecnica = lp.tecnica;
    this.via = lp.via;
    this.tipo = lp.tipo;
    this.temperatura = lp.temperatura;
    this.superficie = lp.superficie;
    this.descontinuidades = lp.descontinuidades;
    this.norma = lp.norma;
    this.itens = lp.itens;
    this.procedimento = lp.procedimento;
    this.observacao = lp.observacao;
    this.penetrante = lp.penetrante;
    this.revelador = lp.revelador;
    this.inspetor = lp.inspetor;
  }

  randomNumber() {
    return parseFloat(Math.random() * (36 - 20) + 20).toFixed(1);
  }

  getDefaultItens() {
    let list = [];
    for (let index = 0; index < 8; index++) {
      list.push({
        quantidade: "- - -",
        descricao: "- - -",
        local: "- - -",
        tipo: "- - -",
        dimensao: "- - -",
        laudo: "- - -",
      });
    }
    return list;
  }
}
